































































































import Vue from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import Loading from "../general/Loading.vue";
import OnscreenMenu from "../../components/general/OnscreenMenu.vue";

import { UserPermissionRank } from "../../shared/UserPermissionRank";
import TableView, { TableViewColumnDefinitions } from "../controls/TableView.vue";

export default Vue.extend({
  name: "StatisticsOverview",
  components: {
    Loading,
    OnscreenMenu,
    TableView,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    appFrameClickedButton: Object,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      supportsDatePicker: false,
      UserPermissionRank: UserPermissionRank,
      rentalStatistics: null as { ID: number; name: string; count: string }[] | null,

      useFilters: false as boolean,
      cachedFilterDates: {
        beginDate: "",
        endDate: "",
      } as { [index: string]: string },
      filterDates: {
        beginDate: "",
        endDate: "",
      } as { [index: string]: string },
    };
  },
  created() {
    this.$emit("showAppFrameButtons", { reload: true });
    this.loadData();
  },
  mounted() {
    this.checkDatePickerSupport();
  },
  methods: {
    loadData() {
      this.loadStatistics();
    },

    checkDatePickerSupport() {
      let testvalue = "a";
      var ele = <HTMLInputElement>this.$refs["testDatePicker"];

      if (ele != null) {
        ele.value = testvalue;

        if (ele.value !== testvalue) {
          this.supportsDatePicker = true;
        }
      }
    },

    async loadStatistics() {
      this.rentalStatistics = null;

      var filterBeginDate = null;
      var filterEndDate = null;

      //filters
      if (this.useFilters) {
        if (this.filterDates["beginDate"] != "") {
          filterBeginDate = new Date(this.filterDates["beginDate"]);
        }
        if (this.filterDates["endDate"] != "") {
          filterEndDate = new Date(this.filterDates["endDate"]);
        }
      }

      if (this.restClient != null) {
        try {
          this.rentalStatistics = await this.restClient.getRentalStatistics(filterBeginDate, filterEndDate);
        } catch (e) {
          alert(e.message);
        }
      }
    },

    //START date handling

    setFilterDates() {
      var filterDate = "";

      let k = this.cachedFilterDates;
      let i: keyof typeof k;

      for (i in this.cachedFilterDates) {
        if (this.supportsDatePicker) {
          filterDate = this.cachedFilterDates[i];
        } else {
          if (this.cachedFilterDates[i].match(/^\d{1,2}.\d{1,2}.\d{4}$/g)) {
            let d = DateFormatter.parseDateString(this.cachedFilterDates[i]);

            if (d != null) {
              filterDate = DateFormatter.formatISODate(d);
            }
          }
        }

        this.filterDates[i] = filterDate;
      }
    },

    //END date handling

    applyUseFilters() {
      this.useFilters = true;
      (this.$refs.filterMenu as any).toggleOnscreenMenu();
      this.loadStatistics();
    },

    removeUseFilters() {
      this.useFilters = false;
      (this.$refs.filterMenu as any).toggleOnscreenMenu();
      this.loadStatistics();
    },
  },
  watch: {
    appFrameClickedButton: function () {
      if (this.appFrameClickedButton.reload) {
        this.loadData();
      }
    },
  },
  computed: {
    rentalTotalCount(): number | undefined {
      if (this.rentalStatistics != null) {
        var totalCount: number = 0;

        for (let i = 0; i < this.rentalStatistics.length; i++) {
          totalCount += parseInt(this.rentalStatistics[i].count);
        }

        return totalCount;
      }
    },

    rentalStatisticsColumns(): TableViewColumnDefinitions<{ ID: number; name: string; count: string }>[] {
      let vue = this;

      return [
        {
          th: "Produkt",
          td: (i) => i.name,
        },
        {
          th: "Anzahl Leihvorgänge",
          td: (i) => i.count,
        },
      ] as TableViewColumnDefinitions<{ ID: number; name: string; count: string }>[];
    },
  },
});
